const feedbackStateKeys = {
	NOT_STARTED: 'feedback_state.not_started',
	IN_PROGRESS: 'feedback_state.in_progress',
	SUBMITTED: 'feedback_state.submitted',
};

const getFeedbackStateKey = (feedbackState) =>
	feedbackState === null ? feedbackStateKeys.NOT_STARTED : feedbackStateKeys[feedbackState];

const getFeedbackDetails = (feedbacks, feedbackRequestId) => {
	const feedback = feedbacks.find(({ feedbackRequestId: id }) => id === feedbackRequestId);

	if (feedback) {
		return {
			interviewerName: feedback.assignedTo.name,
			templateName: Object.values(feedback.feedbackRequestForm.displayNamesMap)[0],
			requestedOn: feedback.requestedOn,
			feedbackStatusKey: getFeedbackStateKey(feedback.feedbackState),
		};
	}

	return {
		interviewerName: '',
		templateName: '',
		requestedOn: '',
		feedbackStatusKey: '',
	};
};

export { getFeedbackStateKey, getFeedbackDetails };
